
import { ACTION_CASHOUT_REGISTER, ACTION_CASHOUT_REGISTER_ERROR, ACTION_CASHOUT_REGISTER_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const cashoutRegisterRequest = (access_token, price, gid, source, appInfo, url) => ({
    type: ACTION_CASHOUT_REGISTER,
    payload: {
        access_token,
        price,
        gid,
        source,
        appInfo,
        url
    }
})

export const cashoutRegisterSuccess = data => ({
    type: ACTION_CASHOUT_REGISTER_SUCCESS,
    payload: {
        data
    }
})


export const cashoutRegisterError = (msg) => ({
    type: ACTION_CASHOUT_REGISTER_ERROR,
    payload: {
        msg
    }
})

export const cashoutRegister = (access_token, price, gid, source, appInfo, url) => {
    return dispatch => {
        dispatch(cashoutRegisterRequest(access_token, price, gid, source, appInfo, url))
        api.cashoutRegister(access_token, price, gid, source, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(cashoutRegisterError("error"));
                    return
                }

                dispatch(cashoutRegisterSuccess("success"));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(cashoutRegisterError("system error"))
            });
    }
}